import { render, staticRenderFns } from "./WhatsOn.vue?vue&type=template&id=10ef6a4c&scoped=true"
import script from "./WhatsOn.vue?vue&type=script&lang=js"
export * from "./WhatsOn.vue?vue&type=script&lang=js"
import style0 from "./WhatsOn.vue?vue&type=style&index=0&id=10ef6a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef6a4c",
  null
  
)

export default component.exports